var map = {
	"./attractions1.png": 716,
	"./attractions2.png": 717,
	"./attractions3.png": 718,
	"./attractions4.png": 719,
	"./attractions5.png": 720,
	"./attractions6.png": 721,
	"./attractions7.png": 722,
	"./attractions8.png": 723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;